<template>
  <!-- Add Comptable -->
  <div class="modal fade" id="add-comptable">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 d-flex justify-content-between custom-modal-header">
              <div class="page-title">
                <h4>Ajouter un comptable</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm" novalidate>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="comptable.first_name"
                        :class="{ 'is-invalid': validationErrors.first_name }"
                        autocomplete="given-name"
                      />
                      <small v-if="validationErrors.first_name" class="text-danger">{{
                        validationErrors.first_name
                      }}</small>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="comptable.last_name"
                        :class="{ 'is-invalid': validationErrors.last_name }"
                        autocomplete="family-name"
                      />
                      <small
                        v-if="validationErrors.last_name"
                        class="text-danger"
                        >{{ validationErrors.last_name }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Email</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="comptable.email"
                        :class="{ 'is-invalid': validationErrors.email }"
                        autocomplete="email"
                      />
                      <small
                        v-if="validationErrors.email"
                        class="text-danger"
                        >{{ validationErrors.email }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Téléphone (optionnel)</label>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="comptable.telephone"
                        :class="{ 'is-invalid': validationErrors.telephone }"
                        autocomplete="tel"
                      />
                      <small
                        v-if="validationErrors.telephone"
                        class="text-danger"
                        >{{ validationErrors.telephone }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">Ajouter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Comptable -->

  <!-- Edit Comptable -->
  <div class="modal fade" id="edit-comptable">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Modifier le comptable</h4>
              </div>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitEditForm" novalidate>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="editComptable.first_name"
                        :class="{ 'is-invalid': validationErrorsEdit.first_name }"
                        autocomplete="given-name"
                      />
                      <small
                        v-if="validationErrorsEdit.first_name"
                        class="text-danger"
                        >{{ validationErrorsEdit.first_name }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="editComptable.last_name"
                        :class="{ 'is-invalid': validationErrorsEdit.last_name }"
                        autocomplete="family-name"
                      />
                      <small
                        v-if="validationErrorsEdit.last_name"
                        class="text-danger"
                        >{{ validationErrorsEdit.last_name }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Email</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="editComptable.email"
                        :class="{ 'is-invalid': validationErrorsEdit.email }"
                        autocomplete="email"
                      />
                      <small
                        v-if="validationErrorsEdit.email"
                        class="text-danger"
                        >{{ validationErrorsEdit.email }}</small
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label>Téléphone (optionnel)</label>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="editComptable.telephone"
                        :class="{
                          'is-invalid': validationErrorsEdit.telephone,
                        }"
                        autocomplete="tel"
                      />
                      <small
                        v-if="validationErrorsEdit.telephone"
                        class="text-danger"
                        >{{ validationErrorsEdit.telephone }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="modal-footer-btn">
                  <button
                    type="button"
                    class="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">Modifier</button>
                </div>
              </form>
              <div class="mt-3">
                <button
                  class="btn btn-danger"
                  @click="deleteComptable(editComptable.id)"
                  v-if="editComptable.id"
                >
                  Supprimer le comptable
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Comptable -->
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import * as Yup from "yup";

// Enhanced validation schemas
const phoneRegex = /^(?:(?:\+|00)212|0)[5-7]\d{8}$/;
const phoneRegexMessage =
  "Format de téléphone marocain invalide. Exemples valides:\n" +
  "• 0600000000\n" +
  "• +212600000000\n" +
  "• 00212600000000";

const addComptableSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("Le prénom est obligatoire")
    .min(2, "Le prénom doit contenir au moins 2 caractères")
    .max(100, "Le prénom ne peut pas dépasser 100 caractères")
    .matches(
      /^[a-zA-ZàâäéèêëïîôöùûüÿçÀÂÄÉÈÊËÏÎÔÖÙÛÜŸÇ\s-']+$/,
      "Le prénom ne doit contenir que des lettres, espaces, tirets et apostrophes"
    ),
  last_name: Yup.string()
    .required("Le nom est obligatoire")
    .min(2, "Le nom doit contenir au moins 2 caractères")
    .max(100, "Le nom ne peut pas dépasser 100 caractères")
    .matches(
      /^[a-zA-ZàâäéèêëïîôöùûüÿçÀÂÄÉÈÊËÏÎÔÖÙÛÜŸÇ\s-']+$/,
      "Le nom ne doit contenir que des lettres, espaces, tirets et apostrophes"
    ),
  email: Yup.string()
    .required("L'email est obligatoire")
    .email("Format d'email invalide")
    .max(100, "L'email ne peut pas dépasser 100 caractères")
    .lowercase("L'email doit être en minuscules"),
  telephone: Yup.string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .test('phone-validation', function(value) {
      if (!value) return true; // Allow empty telephone (optional field)
      
      if (!phoneRegex.test(value)) {
        return this.createError({
          message: phoneRegexMessage
        });
      }
      return true;
    }),
});

const editComptableSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("Le prénom est obligatoire")
    .min(2, "Le prénom doit contenir au moins 2 caractères")
    .max(100, "Le prénom ne peut pas dépasser 100 caractères")
    .matches(
      /^[a-zA-ZàâäéèêëïîôöùûüÿçÀÂÄÉÈÊËÏÎÔÖÙÛÜŸÇ\s-']+$/,
      "Le prénom ne doit contenir que des lettres, espaces, tirets et apostrophes"
    ),
  last_name: Yup.string()
    .required("Le nom est obligatoire")
    .min(2, "Le nom doit contenir au moins 2 caractères")
    .max(100, "Le nom ne peut pas dépasser 100 caractères")
    .matches(
      /^[a-zA-ZàâäéèêëïîôöùûüÿçÀÂÄÉÈÊËÏÎÔÖÙÛÜŸÇ\s-']+$/,
      "Le nom ne doit contenir que des lettres, espaces, tirets et apostrophes"
    ),
  email: Yup.string()
    .required("L'email est obligatoire")
    .email("Format d'email invalide")
    .max(100, "L'email ne peut pas dépasser 100 caractères")
    .lowercase("L'email doit être en minuscules"),
  telephone: Yup.string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .test('phone-validation', function(value) {
      if (!value) return true; // Allow empty telephone (optional field)
      
      if (!phoneRegex.test(value)) {
        return this.createError({
          message: phoneRegexMessage
        });
      }
      return true;
    }),
});

export default {
  data() {
    return {
      // Comptable data structures
      comptable: this.createEmptyComptable(),
      editComptable: this.createEmptyEditComptable(),
      // Validation state
      validationErrors: {},
      validationErrorsEdit: {},
    };
  },

  methods: {
    // Data structure factories
    createEmptyComptable() {
      return {
        first_name: "",
        last_name: "",
        email: "",
        telephone: "",
      };
    },

    createEmptyEditComptable() {
      return {
        id: null,
        first_name: "",
        last_name: "",
        email: "",
        telephone: "",
      };
    },

    // Enhanced validation with better error handling
    async validateComptable(comptableData, schema, context = {}) {
      try {
        await schema.validate(comptableData, {
          abortEarly: false,
          context,
        });
        return {};
      } catch (error) {
        const errors = {};
        if (error.inner && error.inner.length > 0) {
          error.inner.forEach((err) => {
            if (err.path && !errors[err.path]) {
              errors[err.path] = err.message;
            }
          });
        } else if (error.path) {
          errors[error.path] = error.message;
        }
        return errors;
      }
    },

    // Data sanitization
    sanitizeComptableData(comptableData) {
      const sanitized = { ...comptableData };
      // Trim whitespace from string fields
      Object.keys(sanitized).forEach((key) => {
        if (typeof sanitized[key] === "string") {
          sanitized[key] = sanitized[key].trim();
        }
      });

      // Convert email to lowercase
      if (sanitized.email) {
        sanitized.email = sanitized.email.toLowerCase();
      }

      // Format phone number
      if (sanitized.telephone) {
        sanitized.telephone = sanitized.telephone.replace(/\s/g, "");
      }

      return sanitized;
    },

    async submitForm() {
      // Clear previous validation errors
      this.validationErrors = {};

      // Sanitize data
      const sanitizedComptable = this.sanitizeComptableData(this.comptable);

      // Validate with Yup schema
      this.validationErrors = await this.validateComptable(
        sanitizedComptable,
        addComptableSchema
      );

      if (Object.keys(this.validationErrors).length > 0) {
        // Focus on first field with error
        this.focusFirstErrorField();
        return;
      }

      try {
        const payload = {
          first_name: sanitizedComptable.first_name,
          last_name: sanitizedComptable.last_name,
          email: sanitizedComptable.email,
          telephone: sanitizedComptable.telephone || null,
        };

        await axios.post("/comptables", payload);

        // Success handling
        this.$emit("comptable-added");
        this.resetComptable();
        this.hideModal("#add-comptable");
        this.showSuccessMessage("Comptable ajouté avec succès");
      } catch (error) {
        console.error("Add comptable error:", error);
        this.handleApiError(error, "Échec de l'ajout du comptable");
      }
    },

    async submitEditForm() {
      //console.log("submitEditForm called with data:", this.editComptable);
      
      // Clear previous validation errors
      this.validationErrorsEdit = {};

      // Validate that we have an ID
      if (!this.editComptable.id) {
        this.showErrorMessage("Impossible de modifier le comptable (ID manquant)");
        return;
      }

      // Sanitize data
      const sanitizedEditComptable = this.sanitizeComptableData(this.editComptable);
      //console.log("Sanitized data:", sanitizedEditComptable);

      // Validate with Yup schema
      this.validationErrorsEdit = await this.validateComptable(
        sanitizedEditComptable,
        editComptableSchema
      );

      if (Object.keys(this.validationErrorsEdit).length > 0) {
        //console.log("Validation errors:", this.validationErrorsEdit);
        this.focusFirstErrorField(true);
        return;
      }

      try {
        const payload = {
          first_name: sanitizedEditComptable.first_name,
          last_name: sanitizedEditComptable.last_name,
          email: sanitizedEditComptable.email,
          telephone: sanitizedEditComptable.telephone || null,
        };

        //console.log("Sending PUT request to:", `/comptables/${sanitizedEditComptable.id}`);
        //console.log("Payload:", payload);

        const response = await axios.put(`/comptables/${sanitizedEditComptable.id}`, payload);
        //console.log("Update response:", response);

        // Success handling
        this.$emit("comptable-edited");
        this.resetEditComptable();
        this.hideModal("#edit-comptable");
        this.showSuccessMessage("Comptable modifié avec succès");
      } catch (error) {
        console.error("Edit comptable error:", error);
        this.handleApiError(error, "Échec de la modification du comptable");
      }
    },

    async deleteComptable(id) {
      if (!id) {
        this.showErrorMessage("Impossible de supprimer ce comptable (ID manquant).");
        return;
      }

      const result = await Swal.fire({
        title: "Êtes-vous sûr ?",
        text: "Cette action supprimera le comptable définitivement.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
        reverseButtons: true,
        position: 'top-end',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/comptables/${id}`);
          this.$emit("comptable-edited");
          this.resetEditComptable();
          this.hideModal("#edit-comptable");
          this.showSuccessMessage("Comptable supprimé avec succès");
        } catch (error) {
          this.handleApiError(error, "Échec de la suppression du comptable");
        }
      }
    },

    // Utility methods
    resetComptable() {
      this.comptable = this.createEmptyComptable();
      this.validationErrors = {};
    },

    resetEditComptable() {
      this.editComptable = this.createEmptyEditComptable();
      this.validationErrorsEdit = {};
    },

    openEditModal(comptable) {
      //console.log("Opening edit modal with comptable:", comptable);
      this.editComptable = {
        id: comptable.id,
        first_name: comptable.first_name || "",
        last_name: comptable.last_name || "",
        email: comptable.email || "",
        telephone: comptable.telephone || "",
      };
      this.validationErrorsEdit = {};
      //console.log("Edit comptable data set:", this.editComptable);
    },

    focusFirstErrorField(isEdit = false) {
      const errors = isEdit ? this.validationErrorsEdit : this.validationErrors;
      const firstErrorField = Object.keys(errors)[0];
      if (firstErrorField) {
        this.$nextTick(() => {
          const modalId = isEdit ? "#edit-comptable" : "#add-comptable";
          const element = document.querySelector(
            `${modalId} input[name="${firstErrorField}"], ${modalId} select[name="${firstErrorField}"]`
          );
          if (element) {
            element.focus();
          }
        });
      }
    },

    hideModal(selector) {
      const modal = window.bootstrap
        ? window.bootstrap.Modal.getInstance(document.querySelector(selector))
        : null;
      if (modal) {
        modal.hide();
      } else {
        const el = document.querySelector(selector);
        if (el) {
          el.classList.remove("show");
          el.style.display = "none";
          document.body.classList.remove("modal-open");
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) backdrop.parentNode.removeChild(backdrop);
        }
      }
    },

    showSuccessMessage(message) {
      Swal.fire({
        title: "Succès!",
        text: message,
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonClass: "btn btn-success",
        buttonsStyling: false,
        position: 'top-end',
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
        showClass: {
          popup: 'animate__animated animate__slideInRight'
        },
        hideClass: {
          popup: 'animate__animated animate__slideOutRight'
        }
      });
    },

    showErrorMessage(message) {
      Swal.fire({
        title: "Erreur!",
        text: message,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonClass: "btn btn-danger",
        buttonsStyling: false,
        position: 'top-end',
        toast: true,
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
        showClass: {
          popup: 'animate__animated animate__slideInRight'
        },
        hideClass: {
          popup: 'animate__animated animate__slideOutRight'
        }
      });
    },

    handleApiError(error, defaultMessage) {
      console.error(defaultMessage + ":", error);
      
      let message = defaultMessage;
      if (error.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.response?.data?.error) {
        message = error.response.data.error;
      } else if (error.response?.data?.errors) {
        // Handle Laravel validation errors
        const errors = error.response.data.errors;
        const errorMessages = Object.values(errors).flat();
        message = errorMessages.join(', ');
      } else if (error.message) {
        message = error.message;
      }

      this.showErrorMessage(message);
    },
  },

  // Expose methods to parent component
  expose: ['openEditModal', 'resetComptable', 'resetEditComptable'],
};
</script>

<style scoped>
/* ==================== Modal Styles ==================== */
.custom-modal-two .modal-content {
  border-radius: 0px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.custom-modal-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 16px 16px 0 0;
  padding: 1.5rem 2rem;
}

.custom-modal-header .page-title h4 {
  color: #495057;
  font-weight: 600;
  margin: 0;
}

.custom-modal-header .close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.custom-modal-header .close:hover {
  opacity: 1;
  transform: scale(1.1);
}

.custom-modal-body {
  padding: 2rem;
}

/* ==================== Form Styles ==================== */
.input-blocks {
  margin-bottom: 1.5rem;
}

.input-blocks label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  display: block;
  font-size: 0.875rem;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #255EFF;
  box-shadow: 0 0 0 0.2rem rgba(171, 194, 112, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.text-danger {
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: block;
}

/* ==================== Button Styles ==================== */
.modal-footer-btn {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #dee2e6;
}

.btn-cancel {
  background: #6c757d;
  border: 1px solid #6c757d;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #545b62;
  border-color: #545b62;
  transform: translateY(-2px);
}

.btn-submit {
  background: #255EFF;
  border: 1px solid #255EFF;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-submit:hover {
  background: #325697;
  border-color: #325697;
  transform: translateY(-2px);
}

.btn-danger {
  background: #dc3545;
  border: 1px solid #dc3545;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-danger:hover {
  background: #c82333;
  border-color: #c82333;
  transform: translateY(-2px);
}

/* ==================== Responsive Design ==================== */
@media (max-width: 768px) {
  .custom-modal-header,
  .custom-modal-body {
    padding: 1rem;
  }

  .modal-footer-btn {
    flex-direction: column;
  }

  .modal-footer-btn .btn {
    width: 100%;
  }
}
</style>
